import { render, staticRenderFns } from "./pushMessage.vue?vue&type=template&id=db024cfa&scoped=true"
import script from "./pushMessage.vue?vue&type=script&lang=js"
export * from "./pushMessage.vue?vue&type=script&lang=js"
import style0 from "./pushMessage.vue?vue&type=style&index=0&id=db024cfa&prod&lang=css"
import style1 from "./pushMessage.vue?vue&type=style&index=1&id=db024cfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db024cfa",
  null
  
)

export default component.exports